// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-transcript-modal {
  &.MuiFormControl-root {
    margin: 0 !important;
  }
}

.resource-content-name:hover {
  color: #505050;
}

.transcript-action-menu-item {
  color: black !important;
  font-family: Calibri, sans-serif !important;
  font-size: 14px !important;
  margin: 0 5px;
  min-width: 142px;
  padding: 4px 2px !important;
  background-clip: content-box;
  text-align: center !important;
  display: block !important;
}

.transcript-action-button-toggle-hide {
  display: none !important;
}

.transcript-action-button-toggle-show {
  display: table-cell;
}

.transcript-action-menu-item:hover {
  background-color: #fafbff !important;
}

.transcript-certificate-display-toggle-hide {
  display: none !important;
}

.transcript-certificate-display-toggle-show {
  display: flex !important;
}

.transcript-data-cell {
  font-family: Calibri, sans-serif !important;
  font-size: 16px !important;
}

.transcript-header-button {
  margin-left: 5px;
  border-radius: 5px !important;
  white-space: nowrap;
}

.transcript-offering-title {
  font-weight: bold;
}

.transcript-overview-table-row {
  > td,
  > th,
  > th > span {
    font-family: Calibri, sans-serif !important;
    font-size: 16px !important;
  }
}

.transcript-overview-table-row:hover {
  background-color: #fafbff;
}

.transcript-table-header {
  z-index: 1;
  position: relative;
}

td button.transcript-action-button {
  border-radius: 5px;
  font-family: Calibri, sans-serif;
  font-size: 14px;
  max-height: 30px;
  padding: 7px 4px !important;
  background-color: white !important;
  color: black !important;
  border-color: darkgray;
}

.transcripts-date-picker {
  div:has(.MuiInputLabel-root) {
    display: none;
  }
}

.date-filter-search {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-left: 30px;
  margin-top: -4px;
}

.date-pickers-row {
  display: flex;
  flex-direction: row;
  gap: 1em;
  margin-top: 14px;
}

.date-picker-column {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.date-picker-title {
  margin-bottom: 5px;

  span {
    color: red;
  }
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/transcripts/transcripts.css"],"names":[],"mappings":"AAAA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,2CAA2C;IAC3C,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;;EAElB;IACE,UAAU;EACZ;AACF","sourcesContent":[".add-transcript-modal {\n  &.MuiFormControl-root {\n    margin: 0 !important;\n  }\n}\n\n.resource-content-name:hover {\n  color: #505050;\n}\n\n.transcript-action-menu-item {\n  color: black !important;\n  font-family: Calibri, sans-serif !important;\n  font-size: 14px !important;\n  margin: 0 5px;\n  min-width: 142px;\n  padding: 4px 2px !important;\n  background-clip: content-box;\n  text-align: center !important;\n  display: block !important;\n}\n\n.transcript-action-button-toggle-hide {\n  display: none !important;\n}\n\n.transcript-action-button-toggle-show {\n  display: table-cell;\n}\n\n.transcript-action-menu-item:hover {\n  background-color: #fafbff !important;\n}\n\n.transcript-certificate-display-toggle-hide {\n  display: none !important;\n}\n\n.transcript-certificate-display-toggle-show {\n  display: flex !important;\n}\n\n.transcript-data-cell {\n  font-family: Calibri, sans-serif !important;\n  font-size: 16px !important;\n}\n\n.transcript-header-button {\n  margin-left: 5px;\n  border-radius: 5px !important;\n  white-space: nowrap;\n}\n\n.transcript-offering-title {\n  font-weight: bold;\n}\n\n.transcript-overview-table-row {\n  > td,\n  > th,\n  > th > span {\n    font-family: Calibri, sans-serif !important;\n    font-size: 16px !important;\n  }\n}\n\n.transcript-overview-table-row:hover {\n  background-color: #fafbff;\n}\n\n.transcript-table-header {\n  z-index: 1;\n  position: relative;\n}\n\ntd button.transcript-action-button {\n  border-radius: 5px;\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n  max-height: 30px;\n  padding: 7px 4px !important;\n  background-color: white !important;\n  color: black !important;\n  border-color: darkgray;\n}\n\n.transcripts-date-picker {\n  div:has(.MuiInputLabel-root) {\n    display: none;\n  }\n}\n\n.date-filter-search {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  margin-left: 30px;\n  margin-top: -4px;\n}\n\n.date-pickers-row {\n  display: flex;\n  flex-direction: row;\n  gap: 1em;\n  margin-top: 14px;\n}\n\n.date-picker-column {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n}\n\n.date-picker-title {\n  margin-bottom: 5px;\n\n  span {\n    color: red;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
